/**
 * File: nav-landmarks.js
 *
 * Import and initialize functions for proper landmarking
 */

 export default {
	navElements: document.querySelectorAll('nav'),
	init() {
		if (this.navElements > 1) {
			this.render();
		}
	},
	render() {
		const { navElements } = this;

		[...navElements].forEach((nav, i) => {
			if (!nav.hasAttribute('aria-label')) {
				nav.setAttribute('aria-label', `navigation-${i}`)
			}
		});
	},
  };
